import {
  Component,
  OnInit,
  Output,
  ViewChild,
  EventEmitter,
  Input
} from "@angular/core";
import { DataListModel } from "../../shared/config";
import { AuthService } from "../../shared/models/auth.service";
import { Router } from "@angular/router";
import { TranslateService } from "../../shared/translate";
import { OrganizationDriverService } from "../models/organization-driver.service";
import { DriverModel } from "../../driver/models/driver.model";
import { OrganizationDriverMappingModel } from "../models/organization-driver.model";

@Component({
  selector: "wego-organization-driver-list-popup",
  template: require('../views/organization-driver-list-popup.component.html'),
  providers: [OrganizationDriverService]
})
export class OrganizationDriverListPopupComponent implements OnInit {
  SelectedNames: string[] = [];
  SelectedList: string[] = [];
  DataListModel: DataListModel;
  driverList: DriverModel[];
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  LblIcon: string = "fa fa-plus-square";
  isParentCheck: boolean = false;
  organizationHashId: string = "";
  model: OrganizationDriverMappingModel = new OrganizationDriverMappingModel();

  @Input("PageName") pageName: string;
  @Output("OnSuccessSelect") onDriverSelect = new EventEmitter();
  @ViewChild("driverModal") public driverModal: any;

  constructor(
    private organizationDriverService: OrganizationDriverService,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["driverName", "firstName", "lastName"];
  }

  public show(
    SelectedList: string[],
    SelectedNamesList: string[],
    organizationDriverMapping: OrganizationDriverMappingModel
  ): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.SelectedList = SelectedList;
    this.SelectedNames = SelectedNamesList;
    this.model = organizationDriverMapping;
    this.GetOrganizationDriverList();
    this.driverModal.show();
  }

  public hide(): void {
    this.driverModal.hide();
  }

  private GetOrganizationDriverList() {
    this.isLoading = true;
    this.organizationDriverService
      .GetOrganizationBasedDriverList(
        this.DataListModel,
        this.model.customerHashId,
        this.model.instanceHashId,
        this.model.companyHashId,
        this.model.organizationHashId,
        this.pageName
      )
      .subscribe(
        res => {
          this.driverList = res.data;
          this.driverList.forEach(
            x =>
              (x.isChecked =
                this.SelectedList.indexOf(x.driverMasterHashId) > -1)
          );
          // this.isParentCheck = this.driverList.every(x => x.isChecked);

          if (this.driverList) {
            let isCheck = this.driverList.some(x => x.isChecked == true);
            if (isCheck) {
              if (this.driverList.every(x => x.isChecked == true))
                this.isParentCheck = true;
              else this.isParentCheck = false;
            } else {
              this.isParentCheck = false;
            }
          } else {
            this.isParentCheck = false;
          }

          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  private ItemCheckChanged(
    driverMasterHashId: string,
    driverName: string,
    isChecked: any
  ) {
    if (isChecked) {
      if (this.SelectedList.indexOf(driverMasterHashId) == -1) {
        this.SelectedList.push(driverMasterHashId);
      }
      if (this.SelectedNames.indexOf(driverName) == -1) {
        this.SelectedNames.push(driverName);
      }
      this.isParentCheck = this.driverList
        .filter(x => x.driverMasterHashId != driverMasterHashId)
        .every(x => x.isChecked);
    } else {
      this.SelectedList = this.SelectedList.filter(
        x => x != driverMasterHashId
      );
      this.SelectedNames = this.SelectedNames.filter(x => x != driverName);
      this.isParentCheck = false;
    }
  }

  public OnParentCheck(isChecked: boolean) {
    this.driverList.forEach(x => {
      x.isChecked = isChecked;
      if (isChecked) {
        if (this.SelectedList.indexOf(x.driverMasterHashId) == -1) {
          this.SelectedList.push(x.driverMasterHashId);
        }
        if (this.SelectedNames.indexOf(x.driverName) == -1) {
          this.SelectedNames.push(x.driverName);
        }
      } else {
        this.SelectedList = this.SelectedList.filter(
          y => y != x.driverMasterHashId
        );
        this.SelectedNames = this.SelectedNames.filter(y => y != x.driverName);
      }
    });
  }

  private selectMultiple(): void {
    this.isLoading = true;
    this.onDriverSelect.emit({
      DriverHashId: this.SelectedList,
      DriverName: this.SelectedNames
    });
    this.isLoading = false;
    this.hide();
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetOrganizationDriverList();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetOrganizationDriverList();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetOrganizationDriverList();
  }
  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetOrganizationDriverList();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organizationdriver/components/organization-driver-list-popup.component.ts